<template>
    <section class="section section-lg bg-default text-center">
        <div class="container">
          <div class="row justify-content-sm-center">
            <div class="col-md-14 col-xl-14">
                <h3>Daily Sync Workers</h3>
                <div class="table-novi table-custom-responsive">
                    <span class="job-status">PENDING JOBS: {{ pendingJobs }}, SYNC JOBS: {{ syncJobs }}, FAILED JOBS: {{ failedJobs }}</span>
                    <div class="refresh-interval-container">
                        <select v-model="dailysync.refreshInterval" class="form-control form-control-md" @change="updateRefreshInterval">
                            <option value="0">Select Table Refresh Interval</option>
                            <option value="10000">Refresh table every 10 Seconds</option>
                            <option value="20000">Refresh table every 20 Seconds</option>
                            <option value="30000">Refresh table every 30 Seconds</option>
                            <option value="60000">Refresh table every 1 minute</option>
                            <option value="180000">Refresh table every 3 minute</option>
                        </select>
                    </div>
                    <table class="table-custom table-custom-bordered">
                        <thead>
                            <tr>
                            <th class="header-text" title="Number of workers">
                                <span v-if="!dailysync.loading">#</span>
                                <img v-if="dailysync.loading" class="loading-indicator" src="/images/eowp/animation/loading-spinner.jpg" />
                            </th>
                            <th class="header-text">Name</th>
                            <th class="header-text">Capacity/Process/Delay</th>
                            <th class="header-text">Reserved</th>
                            <th class="header-text">Progress</th>
                            <th class="header-text">Updated By</th>
                            <th class="header-text">Status</th>
                            <th class="header-text">
                                <a title="Add Worker" class="novi-icon icon icon-md-smaller icon-filled mdi mdi-account-plus" href="#" @click="newWorker()"></a>
                            </th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="(obj, index) in dailysync.workers" v-bind:key="'nth-'+index">
                            <td :class="obj.enabled ? '' : 'row-disabled'" class="text-align-center">{{ index + 1 }}</td>
                            <td :class="obj.enabled ? '' : 'row-disabled'">{{ textLimit(obj.name, 9) }}</td>
                            <td :class="obj.enabled ? '' : 'row-disabled'" class="text-align-center">{{ obj.capacity + " / " + obj.process + " / " + obj.delay }}</td>
                            <td :class="obj.enabled ? '' : 'row-disabled'">{{ obj.reserved }}</td>
                            <td :class="obj.enabled ? '' : 'row-disabled'">{{ obj.progress }}</td>
                            <td :class="obj.enabled ? '' : 'row-disabled'" :title="obj.updatedBy">{{ textLimit(obj.updatedBy, 15) }}</td>
                            <td :class="obj.enabled ? 'indicator-enabled' : 'row-disabled indicator-disabled'">{{ obj.enabled ? 'ENABLED' : 'DISABLED' }}</td>
                            <td :class="obj.enabled ? '' : 'row-disabled'" class="text-align-center">
                                <div class="option-buttons">
                                        <a title="Edit Worker" class="novi-icon icon icon-md-smaller icon-filled mdi mdi-message-draw" href="#" @click="editWorker(obj.id)"></a>
                                        &nbsp;&nbsp;&nbsp;
                                        <a title="Delete Worker" class="novi-icon icon icon-md-smaller icon-filled mdi mdi-delete-variant" href="#" @click="deleteWorker(obj.id, obj.name)"></a>
                                </div>
                            </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
          </div>
          <ManageWorkerDialog v-if="dialog.enabled" :workerId="dialog.workerId" :userEmail="user" :sessionId="userSessionId" v-on:close="closeDialog" v-on:submit="dialogSubmitted"></ManageWorkerDialog>
        </div>
      </section>
</template>

<style scoped>
/** styles that reflect within this component only */
.refresh-interval-container > select {
    height: 47px !important;
    padding-left: 7px;
    padding-right: 7px;
}
.refresh-interval-container{
    height: 45px;
    margin-bottom: 10px;
}
.loading-indicator{
    position: relative;
    display: block;
    height: auto;
    max-width: 25px;
}
.job-status{
    font-size: 17px;
    font-weight: 600;
    padding-bottom: 15px;
    position: relative;
    display: block;
    color: rgb(233, 105, 1);
}
.option-buttons{
    width: 50px;
}
.row-disabled{
    background-color: rgb(241 241 241);
    color: rgb(129, 129, 129);
}
.header-text{
    text-align: center !important;
    cursor: default;
    background-color: rgb(241 241 241);
    border-color: rgb(241 241 241);
    font-weight: 600;
}
.text-align-center{
    text-align: center !important;
}
.indicator-enabled{
    text-align: center !important;
    font-weight: 600;
    color: rgb(4, 134, 4);
}
.indicator-disabled{
    text-align: center !important;
    font-weight: 600;
    color: rgb(226, 101, 17);
}
.box-inline{
    font-size: 22px!important;
    padding-bottom: 10px!important;
}
table td {
    cursor: default;
}
</style>

<script>
import Utils from '../../../../js/helpers/Utils';
import { mapActions, mapGetters } from 'vuex';
import ManageWorkerDialog from '../../../component/worker/manage-worker-dialog';

export default {
    data() {
        return {
            dailysync: {
                workers: [],
                refreshObject: null,
                refreshInterval: 0,
                loading: true,
            },
            dialog: {
                enabled: false,
                workerId: '',
            },
            dialogParams: {
                defaultOptions: {
                    loader: false,
                    okText: 'Delete',
                    cancelText: 'Cancel',
                    animation: 'zoom',
                    backdropClose: true
                },
                alertOptions: {
                    loader: false,
                    okText: 'Close',
                    cancelText: 'Close',
                    animation: 'zoom',
                    backdropClose: true
                }
            }
        };
    },
    created() {
        //Initialize all processes here
        let params = {
            userEmail: this.user,
            sessionId: this.userSessionId
        };
        this.isOperationEnabled(params).then(res => {
            if(!res.records){
                this.$router.push("/products");
            }
        });
        this.updateWorkerList();
    },
    computed: {
        //Auto execute codes every time there's a change of values here
        ...mapGetters({
            user: 'user/user',
            userSessionId: 'user/session',
            workerList: 'worker/worker_list',
            failedJobs: 'worker/failed_jobs',
            pendingJobs: 'worker/pending_jobs',
            syncJobs: 'worker/sync_jobs',
        }),
    },
    methods: {
        //All methods here
        ...mapActions({
            removeWorker: 'worker/removeWorker',
            getAllWorkers: 'worker/getAllWorkers',
            isOperationEnabled: 'worker/isOperationEnabled',
        }),
        textLimit(value, limit){
            if(Utils.isEmpty(value) || value.length <= limit) return value;
            return value.substring(0, limit) + "...";
        },
        updateWorkerList(){
            this.dailysync.loading = true;
            let params = {
                userEmail: this.user,
                sessionId: this.userSessionId
            };
            let vm = this;
            this.getAllWorkers(params).then((res) => {
                if(res.status_code != "ERR0") window.location.reload();
                vm.dailysync.workers = this.workerList.map(worker => {
                    return {
                        id: worker.id,
                        name: worker.codeName,
                        capacity: worker.capacity,
                        process: worker.process,
                        delay: worker.delay,
                        updatedBy: worker.updatedBy,
                        enabled: worker.enabled,
                        reserved: worker.reservedJobs,
                        progress: worker.inProgressJobs
                    };
                });
                setTimeout(() => {
                    vm.dailysync.loading = false;
                }, 200);
            });
        },
        newWorker(){
            this.dialog.workerId = '';
            this.dialog.enabled = true;
        },
        editWorker(workerId){
            this.dialog.workerId = workerId;
            this.dialog.enabled = true;
        },
        async deleteWorker(workerId, workerName){
            await this.$dialog.confirm({
                    title: 'Confirm Delete Worker',
                    body: 'Are you sure you want to delete this worker (' + workerName + ')? This cannot be undone.',
                }, this.dialogParams.defaultOptions)
            .then(() => {
                let params = {
                    userEmail: this.user,
                    sessionId: this.userSessionId,
                    id: workerId
                };
                this.removeWorker(params).then(res => {
                    if(res.status_code != "ERR0"){
                        if(res.status_code == "ERR8"){
                            this.infoDialog("Operation Not Allowed", res.description);
                        }else{
                            top.window.location.reload();
                        }
                    }
                });
            }).catch(() => {});
            this.dialogSubmitted();
        },
        closeDialog(){
            this.dialog.workerId = '';
            this.dialog.enabled = false;
        },
        dialogSubmitted(){
            let vm = this;
            setTimeout(() => {
                vm.updateWorkerList();
            }, 200);
            this.closeDialog();
        },
        updateRefreshInterval(){
            if(this.dailysync.refreshObject){
                clearInterval(this.dailysync.refreshObject);
            }

            if(this.dailysync.refreshInterval > 0){
                let vm = this;
                this.dailysync.refreshObject = setInterval(() => {
                    vm.updateWorkerList();
                }, this.dailysync.refreshInterval);
            }
        },
        infoDialog(title, message){
            this.$dialog.alert({
                title: title,
                body: message,
            }, this.dialogParams.alertOptions)
            .then(() => {})
            .catch(() => {});
        }
    },
    components: {
        ManageWorkerDialog
    }
};
</script>
